export default __webpack_public_path__ + "static/media/expert_banner.07a1eb8d.jpg";